import React from 'react';
import cn from 'classnames';
import { CalendarOutlined } from '@ant-design/icons';
// Types
import { GetCampaignOffers_getCampaignOffers_entities_deliverablesV2 } from 'api/campaignV2/types/GetCampaignOffers';
// Helpers
import { getDateLabelFromDeliverable } from 'helpers/deliverables';
// UI
import Text from 'uiShared/Text/Text';
// Components
import DropdownItem from 'components/common/SocialCampaignV2Components/DropdownItem/DropdownItem';
// Styles
import styles from './DeliverablePublishCard.module.scss';

type DeliverablePublishCardProps = {
  deliverable: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2;
  className?: string;
  showDescription?: boolean;
  showDivider?: boolean;
  notice?: string;
  isUploadAllowed?: boolean;
  children?: React.ReactNode;
};

const DeliverablePublishCard: React.FC<DeliverablePublishCardProps> = ({
  deliverable,
  className,
  showDescription = true,
  showDivider = true,
  notice,
  isUploadAllowed = false,
  children,
}) => {
  const getStatusLabel = () => {
    if (!deliverable?.status) return null;
    return deliverable.status.replace(/_/g, ' ').toLowerCase();
  };

  const title = deliverable?.task?.title;

  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.content}>
        <div className={styles.labelSection}>
          <div className={styles.deliverableLabel}>
            Deliverable {(deliverable?.task?.orderIdx ?? 0) + 1}: {title} - Post
          </div>
          {getStatusLabel() && (
            <div className={styles.status}>{getStatusLabel()}</div>
          )}
        </div>

        <div className={styles.titleSection}>
          <div className={styles.stats}>
            <div className={styles.statItem}>
              <div className={styles.statContent}>
                <div className={styles.icon}>
                  <CalendarOutlined />
                </div>
                <Text className={styles.statLabel}>Publish Due Date:</Text>
                <Text className={styles.statValue}>
                  {getDateLabelFromDeliverable('publish', deliverable)}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDescription && (
        <DropdownItem
          label="DESCRIPTION"
          labelClassName={styles.descriptionLabel}
          defaultExpanded={isUploadAllowed}
        >
          <Text className={styles.description} color="black">
            {deliverable.task?.description}
          </Text>
        </DropdownItem>
      )}

      {showDivider && <div className={styles.divider} />}

      {!children ? (
        <div className={styles.notSubmittedDesc}>
          <Text className={styles.noticeText}>
            {notice ||
              'This is a posting deliverable - when the time comes, you can publish it.'}
          </Text>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default DeliverablePublishCard;
